import styled from '@emotion/styled';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import logoImg from 'src/public/img/mh-logo-text.svg';
import { BodyTextMedium, HeadingText50 } from '@modernhealth/vital-components';
import { ReactComponent as Illustration } from 'src/public/ds/illustrations/fish.svg';
import { color } from 'src/shared/styles/variables';
import { NonExistentLinkTestId } from './testIds';
import { config } from 'src/config/config';

const Container = styled.div({
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
});

const ContentWrapper = styled.div({
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '29rem',
    margin: '0 auto',
});

const BrandImage = styled.img({
    marginLeft: 32,
    marginTop: 20,
    width: '15em',
    cursor: 'pointer',
    marginRight: 12,
});

const Link = styled.a({
    display: 'inline',
    textDecoration: 'underline',
    color: color.royalBlue,
});

export const NonExistentLink: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <BrandImage
                src={logoImg}
                onClick={() => {
                    window.location.href = config.modernHealthURL;
                }}
            />
            <Container>
                <ContentWrapper>
                    <Illustration width={200} />
                    <HeadingText50 centered marginTop={25}>
                        {t('translation:invalid_link_title')}
                    </HeadingText50>
                    <BodyTextMedium centered testID={NonExistentLinkTestId.InvalidLinkDescription}>
                        <Trans
                            t={t}
                            ns="auth"
                            i18nKey="translation:invalid_link_description"
                            components={{
                                a: <Link href="mailto:help@joinmodernhealth.com" />,
                            }}
                        />
                    </BodyTextMedium>
                </ContentWrapper>
            </Container>
        </>
    );
};
